import React from "react";
import "./whatsapp.css";
import WhatsAppImg from "./WhatsApp.png";
const Whatsapp = () => {
  return (
    <>
      <a
        href="https://web.whatsapp.com/send?phone=8188854509"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="WhatsappImg" src={WhatsAppImg} alt="WhatsApp" />
      </a>
    </>
  );
};

export default Whatsapp;
